import React, { FC } from "react";
import { Button, Icon, Toggle } from "@telia/teddy";
import { useAppearance } from "../../../../app/hooks/useAppearance";
import "./AppearanceToggle.less";

const AppearanceToggle: FC = () => {
    const { resolved, setPreference } = useAppearance();

    const isDark = resolved === "dark";

    return (
        <div className="appearance-toggle">
            <Toggle>
                <Toggle.Label>
                    <Icon name={isDark ? "sun" : "moon"}>Natt modus</Icon>
                </Toggle.Label>
                <Toggle.Input
                    checked={isDark}
                    onCheckedChange={(checked: boolean) => setPreference(checked ? "dark" : "light")}
                />
            </Toggle>
            <Button variant="text" onClick={() => setPreference("system")}>
                Bruk systeminnstilling
            </Button>
        </div>
    );
};

export default AppearanceToggle;
